
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const OceanImpact = () => {
  return (
    <section id="impact" className="py-24 bg-gradient-to-b from-black to-[#1A1F2C] relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-400 to-orange-600">
              Ocean Outlaw Fund
            </span>
          </h2>

          <Card className="bg-gradient-to-br from-black/80 to-blue-900/20 text-white border-blue-500/20 shadow-2xl overflow-hidden relative">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCI+PGNpcmNsZSBjeD0iMjUiIGN5PSIyNSIgcj0iMSIgZmlsbD0icmdiYSgwLCAxNTAsIDI1NSwgMC4wNSkiIC8+PC9zdmc+')]"></div>
            
            <CardContent className="pt-10 px-6 md:px-10 relative z-10 bg-black">
              <div className="mb-8">
                <img 
                  src="/lovable-uploads/9ad38211-674b-476d-8b49-017db8505fd8.png"
                  alt="Beach cleanup with plastic bottle in sand"
                  className="w-full h-auto rounded-lg shadow-xl mb-8"
                />
              </div>
              
              <div className="flex items-center justify-center mb-8">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-full flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22a8 8 0 0 0 8-8c0-3.5-2-6.5-4-9 l-4-4-4 4c-2 2.5-4 5.5-4 9a8 8 0 0 0 8 8z"></path>
                    <path d="M12 22V11"></path>
                    <path d="M8 14l4-3 4 3"></path>
                  </svg>
                </div>
              </div>

              <div className="text-center">
                <p className="text-xl md:text-2xl leading-relaxed text-gray-200 mb-8">
                  "Every swap fuels our covert rescue crew—no boardroom virtue signals, just direct-to-sea action keeping flippers flipping."
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
                  <div className="p-5 bg-gradient-to-br from-blue-600 to-blue-800 backdrop-blur-sm rounded-lg border border-blue-500/20">
                    <h4 className="font-bold text-lg mb-2">Direct Impact</h4>
                    <p className="text-gray-300 text-sm">
                      Supporting real world marine conservation efforts with every trade
                    </p>
                  </div>
                  
                  <div className="p-5 bg-gradient-to-br from-blue-600 to-blue-800 backdrop-blur-sm rounded-lg border border-blue-500/20">
                    <h4 className="font-bold text-lg mb-2">Transparency</h4>
                    <p className="text-gray-300 text-sm">
                      Public ledger tracking all donations and conservation results
                    </p>
                  </div>
                  
                  <div className="p-5 bg-gradient-to-br from-blue-600 to-blue-800 backdrop-blur-sm rounded-lg border border-blue-500/20">
                    <h4 className="font-bold text-lg mb-2">Community Votes</h4>
                    <p className="text-gray-300 text-sm">
                      $POP holders decide which conservation efforts to fund next
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      
      {/* Water ripple animation */}
      <div className="absolute bottom-0 left-0 right-0 h-16 overflow-hidden">
        <div className="ripple-bottom-1"></div>
        <div className="ripple-bottom-2"></div>
      </div>
    </section>
  );
};

export default OceanImpact;
